import { textAlign } from "@mui/system";
import React from "react";
import ReactSpeedometer from "react-d3-speedometer";

const styles = {
  dial: {
    display: "inline-block",
    width: `300px`,
    // height: `auto`,
    color: "#000",
    border: "0.5px solid #fff",
    padding: "2px"
  },
  title: {
    fontSize: "0.8em",
    color: "#000",
    textAlign: "center",

  }
};

const Chargemeter = ({ id, height, maxValue, value, title }) => {
  return (
    <div style={styles.dial}>
      <ReactSpeedometer
        maxValue={maxValue}
        minValue={0}
        height={height}
        // width={360}
        value={value}
        valueFormat=".1f"
        needleTransition="easeQuadIn"
        needleTransitionDuration={1000}
        needleColor="red"
        startColor="green"
        segments={5}
        endColor="red"

        // customSegmentLabels={
        //   [
        //     {
        //       // text:"Very Poor",
        //       text:"0",
        //       position:"OUTSIDE",
        //       // color: "#fff",
        //       fontSize:"0.8em",
        //     },
        //     {
        //       text:"Poor",
        //       position:"INSIDE",
        //     },
        //     {
        //       text:"Fair",
        //       position:"INSIDE",
        //     },
        //     {
        //       text:"Good",
        //       position:"INSIDE",
        //     },
        //     {
        //       text:"Excellent",
        //       position:"INSIDE",
        //     }

        //   ]
        // }
      />
      <div style={styles.title}> {title} </div>
    </div>
  );
};

export default Chargemeter;
